import script from "./StepAssetDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./StepAssetDetails.vue?vue&type=script&setup=true&lang=js"

import "./StepAssetDetails.vue?vue&type=style&index=0&id=af6db5fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af6db5fa"]])

export default __exports__